import axios from "../interceptors/axios";

export default class AgeRatingService {

  /**
   * Listagem pública — todos os registros ordenados por age ASC.
   * Usado no select do formulário de obra.
   * GET /api/age_rating
   */
  index = async () => {
    try {
      const response = await axios.get("/api/age_rating");
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

  /**
   * Listagem paginada com filtro — uso do painel admin.
   * GET /api/age_rating/list
   */
  list = async (params = {}) => {
    try {
      const response = await axios.get("/api/age_rating/list", { params });
      return response;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

  /**
   * Cria nova faixa etária.
   * POST /api/age_rating/create
   */
  create = async (data) => {
    try {
      const response = await axios.post("/api/age_rating/create", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  /**
   * Atualiza faixa etária existente.
   * PUT /api/age_rating/edit
   */
  edit = async (data) => {
    try {
      const response = await axios.put("/api/age_rating/edit", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  /**
   * Remove faixa etária.
   * DELETE /api/age_rating/delete?id=X
   */
  delete = async (params) => {
    try {
      const response = await axios.delete("/api/age_rating/delete", { params });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

}
